setTimeout(() => {
  const $theme_preview_bar = jQuery('#preview-bar-iframe');
  console.log($theme_preview_bar.first().contents().find('.admin-bar p').text().trim());
  console.log($theme_preview_bar.first().contents().find('#share_theme_url').val());
  $theme_preview_bar.hide();
}, 3000);

/* Shopify */
typeof Shopify == 'undefined' ? {} : Shopify;
Shopify.money_format = "${{amount_no_decimals}}";
Shopify.formatMoney = function (cents, format) {
    if (typeof cents == 'string') { cents = cents.replace('.', ''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);

    function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) { return 0; }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents = parts[1] ? (decimal + parts[1]) : '';

        return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }

    return formatString.replace(placeholderRegex, value);
};

/* T&Cs Checkbox */
// $(() => {
//   $('cart-drawer').on('change', '#terms-checkbox', (e) => {
//     $('#CartDrawer-Checkout').prop('disabled', !$(e.target).is(':checked'));
//   });
// });

// Bundler (Shopify App)
document.addEventListener('bundler:bundle_widget_created', function(e) {
  //console.log(e);
  document.querySelectorAll('.bndlr-product [data-currentprice]').forEach(function(el, index) {
      el.innerHTML = Shopify.formatMoney(parseInt(el.dataset.currentprice) / 11 * 10) + ' Ex GST';
  });
});

// Serial-number Form 
class SerialNumberForm extends HTMLElement {
  constructor() {
    super();
    this.mainSectionId = this.getMainSectionId();
    this.priceElement = document.querySelector(`#price-${this.mainSectionId}`);
    this.originalPrice = 200.00;
    this.deliveryOptions = this.querySelectorAll('input[name="properties[Return Delivery]"]');
    this.init();
  }

  // Method to identify the main section ID dynamically
  getMainSectionId() {
    const mainSection = document.querySelector('section[id^="shopify-section-template--"][id$="__main"]');
    if (mainSection) {
      return mainSection.id.match(/template--\d+__main/)[0];
    } else {
      console.error('Main section not found');
      return null;
    }
  }

  init() {
    this.updatePrice();
    this.deliveryOptions.forEach(option => {
      option.addEventListener('change', this.updatePrice.bind(this));
    });
  }

  updatePrice() {
    let finalPrice = this.originalPrice;
    this.deliveryOptions.forEach(option => {
      if (option.checked) {
        const adjustment = parseFloat(option.getAttribute('data-price-adjustment'));
        finalPrice += adjustment;
      }
    });
    // Update the price element's text content with the calculated final price
    if (this.priceElement) {
      this.priceElement.textContent = `${finalPrice.toFixed(2)} AUD`;
    } else {
      console.error('Price element not found');
    }
  }
}

// Define the custom element
customElements.define('return-delivery', SerialNumberForm);

// Declare map as a global variable
window.map = null;
window.marker = null;

// Async function to initialize the map
async function initMap() {
  const position = { lat: -27.4825959, lng: 153.0388392 };

  const { Map } = await google.maps.importLibrary("maps");
  const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

  // Initialize the map
  window.map = new Map(document.getElementById("map"), {
    zoom: 14,
    center: position,
    mapId: "DEMO_MAP_ID",
  });

  // Create a marker positioned at the specified position
  window.marker = new AdvancedMarkerElement({
    map: window.map,
    position: position,
    title: "Sure Power",
  });
}

// Function to set the center of the map
function setMapCenter(lat, lng) {
  if (window.map) {
    window.map.setCenter({ lat: lat, lng: lng });

    addMarker(lat, lng)
  }
}

function addMarker(lat, lng) {
  window.marker = new google.maps.Marker({
    map: window.map,
    position: { lat: lat, lng: lng },
    title: "Sure Power",
  })
}
